<template>
	<div class="brick">
		<label v-if="restriction_only_available" class="mgr_15"><input type="checkbox" v-model="restriction_only" @change="onStateReportChange" /> Restriction Only</label>
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_10">
					<em class="lt_text mgr_5">Invoive Date </em>
					<span class="mgr_15">
						<CustomDatePicker v-model.trim="from_date" /> ~
						<CustomDatePicker v-model.trim="to_date" />
					</span>

					<label class="mgr_15">
						<input type="checkbox" v-model="is_detail" @change="changeMode" />
						<em class="lt_text">Show Detail</em>
					</label>

					<span v-if="is_detail" class="mgr_10">
						<label class="mgr_5">
							<input type="radio" v-model="detail_mode" value="ALL" @change="changeMode" />
							<em class="lt_text">ALL</em>
						</label>
						<label class="mgr_5">
							<input type="radio" v-model="detail_mode" value="SALES" @change="changeMode" />
							<em class="lt_text">SALES</em>
						</label>
						<label class="mgr_5">
							<input type="radio" v-model="detail_mode" value="RETURN" @change="changeMode" />
							<em class="lt_text">RETURN</em>
						</label>
						<label class="mgr_5">
							<input type="radio" v-model="detail_mode" value="CREDIT" @change="changeMode" />
							<em class="lt_text">CREDIT</em>
						</label>
					</span>
				</p>

				<SelectPartners :restrictionOnly="restriction_only" :ref="'select_partners'" v-model.trim="customer_codes" :delim="delim" class="mgb_10" />

				<p>
					<em class="lt_text">Sales Group</em>
					<span class="int_type_no_border"
						><CodeSelect className="tbl_select" v-model="selected_sales_group" :codes="restriction_only && state_report_filters ? state_report_filters.restrictionOnlySalesGroupList : salesGroups" :showDesc="false" @set-code="setSalesGroupArr"
					/></span>
					<span class="int_type_no_border mgr_15">
						<input type="text" class="tbl_int" v-model.trim="sales_group_string" style="width:300px;" placeholder="Select Multiple Sales Group" />
					</span>
					<a href="javascript:;" class="search_bt mgr_5" @click="search()">Search</a>
					<a href="javascript:;" class="gray_bt mgr_15" @click="excel()">Excel</a>

					<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>
				</p>
			</div>
		</div>
		<CommonTable :tbl_headers="tbl_headers" :data="display_records" :sort_key="sort_key" :sort_direction="sort_direction" @sort="sort" />
	</div>
</template>

<script>
import stateReport from '@/mixins/stateReport';
import CommonTable from '@/components/common/commonTable/CommonTable.vue';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import SelectPartners from '@/components/common/SelectPartners.vue';
import CodeSelect from '@/components/common/CodeSelect';
import { apiSelectSalesByCustomer } from '@/api/report/report.js';
import { apiSelectSalesGroupList } from '@/api/basicinfo/salesgroup.js';
import { exportDataExcel, objectCopy } from '@/api/util';
import { today, daysAgo } from '@/utils/date.js';
import { inputSelectOnClick } from '@/utils/etc.js';
import { defaultDataType } from 'export-xlsx';
export default {
	mixins: [stateReport({ id: 'SalesByCustomer', search: 'search', queries: ['search'], results: ['sales_list_by_customer', 'total_list'] })],
	data: () => ({
		from_date: daysAgo(6),
		to_date: today(),
		customer_codes: null,
		sort_key: null,
		sort_direction: null,

		sales_list_by_customer: [],
		total_list: [],

		search_from_date: null,
		search_to_date: null,

		delim: ',',

		salesGroups: [],
		sales_group_string: null,
		selected_sales_group: null,

		is_detail: false,
		detail_mode: 'ALL',

		display_records: [],
		tbl_headers: [],
	}),
	components: {
		CustomDatePicker,
		SelectPartners,
		CodeSelect,
		CommonTable,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		customer_code_arr() {
			return this.customer_codes ? this.customer_codes.split(this.delim) : [];
		},
		sales_group_arr() {
			return this.sales_group_string ? this.sales_group_string.split(this.delim) : [];
		},
		init_detail_mode() {
			return false;
		},
		is_arkin() {
			return this.company_id === 'arkin';
		},
	},
	methods: {
		sort(header) {
			const sort_key = header.key;

			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.makeDisplaySimple();
		},
		reset() {
			this.from_date = daysAgo(6);
			this.to_date = today();
			this.sort_key = null;
			this.sort_direction = null;

			this.$refs.select_partners.reset();
			this.sales_group_string = null;
			this.selected_sales_group = null;
		},
		setSalesGroupArr(sg) {
			if (!sg || this.sales_group_arr.findIndex(el => el === sg.code) > -1) return;

			if (this.sales_group_string) this.sales_group_string += this.delim + sg.code;
			else this.sales_group_string = sg.code;
		},
		excel() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			if (!(this.display_records && this.display_records.length > 0)) return this.$toast.error('No Data to Export');

			let headerGroups;
			if (!this.is_detail) {
				headerGroups = [{ key: 'period', name: 'Search Period: ' + this.search_from_date + ' ~ ' + this.search_to_date }];
			}

			if (!state_output.valid) return;

			exportDataExcel(this.display_records, this.tbl_headers, 'SalesByCustomer', headerGroups);
		},
		arraySort(arr, cri, reverse) {
			arr.sort((a, b) => {
				let res;
				if (a[cri] > b[cri]) res = 1;
				else if (a[cri] < b[cri]) res = -1;
				else res = 0;

				return reverse ? res * -1 : res;
			});
		},
		multiSort(arr, cri_arr) {
			const prev_cri_arr = [];
			for (const cri_obj of cri_arr) {
				const cri = cri_obj.cri;
				const reverse = cri_obj.reverse;
				arr.sort((a, b) => {
					let res;
					let is_stop = false;
					for (const prev of prev_cri_arr) {
						if (a[prev] !== b[prev]) {
							is_stop = true;
							break;
						}
					}

					if (is_stop) {
						res = 0;
					} else {
						if (a[cri] > b[cri]) res = 1;
						else if (a[cri] < b[cri]) res = -1;
						else res = 0;
					}

					return reverse ? res * -1 : res;
				});

				prev_cri_arr.push(cri);
			}
		},
		getFilter() {
			if (this.detail_mode === 'SALES') {
				return function(el) {
					return el.sales_number > 0;
				};
			} else if (this.detail_mode === 'RETURN') {
				return function(el) {
					return el.return_number > 0;
				};
			} else if (this.detail_mode === 'CREDIT') {
				return function(el) {
					return el.credit_number > 0;
				};
			} else {
				return function(el) {
					return el.sales_group_code;
				};
			}
		},
		getTotalRow(sales_group_code) {
			let total_row = {};
			if (Array.isArray(this.total_list)) {
				const idx = this.total_list.findIndex(el => el.sales_group_code === sales_group_code);
				if (idx > -1) {
					total_row = objectCopy(this.total_list[idx]);
					total_row.tr_class = ['bg_gray'];
				}
			}

			return total_row;
		},
		changeMode() {
			this.setHeader();

			if (!this.sales_list_by_customer || !this.sales_list_by_customer.length) {
				this.display_records = [];
				return;
			}

			if (this.is_detail) {
				if (!this.detail_mode) this.detail_mode = 'ALL';
				this.makeDisplayDetail();
			} else {
				this.makeDisplaySimple();
			}
		},
		setHeader() {
			if (!this.is_detail) this.tbl_headers = this.simpleHeader();
			else if (this.detail_mode === 'SALES') this.tbl_headers = this.salesHeader();
			else if (this.detail_mode === 'RETURN') this.tbl_headers = this.returnHeader();
			else if (this.detail_mode === 'CREDIT') this.tbl_headers = this.creditHeader();
			else this.tbl_headers = this.allHeader();
		},
		makeDisplaySimple() {
			const display_records = this.sales_list_by_customer.filter(el => !!el);
			this.arraySort(display_records, this.sort_key || 'partner_code', this.sort_direction === 'DESC');
			display_records.push(this.getTotalRow('GRAND_TOTAL'));

			this.display_records = display_records;
		},
		makeDisplayDetail() {
			const makeTotalRow = (code, cust_cnt) => {
				const total = this.getTotalRow(code);
				if (cust_cnt) total.sales_group_code = `${total.sales_group_code}(${cust_cnt})`;

				return total;
			};

			const display_records = this.sales_list_by_customer.filter(this.getFilter());
			this.multiSort(display_records, [
				{ cri: 'sg_order_no', reverse: false },
				{ cri: 'sales_group_code', reverse: false },
				{ cri: 'partner_code', reverse: false },
			]);

			if (display_records.length > 0) {
				let prev_code = display_records[0].sales_group_code;
				let cust_cnt = 1;
				for (let i = 1; i < display_records.length; i++) {
					const sales_group_code = display_records[i].sales_group_code;
					if (prev_code !== sales_group_code) {
						display_records.splice(i, 0, makeTotalRow(prev_code, cust_cnt));
						prev_code = sales_group_code;
						cust_cnt = 0;
					} else {
						cust_cnt++;
					}
				}
				display_records.push(makeTotalRow(prev_code, cust_cnt));
				display_records.push(this.getTotalRow('GRAND_TOTAL'));
			}

			this.display_records = display_records;
		},

		simpleHeader() {
			if (this.is_arkin) {
				return [
					{ key: 'partner_code', groupKey: 'period', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '12%', td_class: 'al_left', th_click_event: 'sort' },
					{ key: 'name', groupKey: 'period', name: 'Name', width: 25, dataType: defaultDataType.string, tbl_width: '22%', td_class: 'al_left', th_click_event: 'sort' },
					{ key: 'sales_quantity', groupKey: 'period', name: 'QTY', width: 10, dataType: defaultDataType.number, tbl_width: '10%', td_class: 'al_right', display_filter: 'commaSeparated', th_click_event: 'sort' },
					{ key: 'gross_sale_amount', groupKey: 'period', name: 'Gross Sale($)', width: 15, dataType: defaultDataType.number, tbl_width: '14%', td_class: 'al_right', display_filter: 'toCurrency', th_click_event: 'sort' },
					{ key: 'total_cost', groupKey: 'period', name: 'Cost Amount($)', width: 15, dataType: defaultDataType.number, tbl_width: '14%', td_class: 'al_right', display_filter: 'toCurrency', th_click_event: 'sort' },
					{ key: 'gross_profit', groupKey: 'period', name: 'Gross Profit($)', width: 15, dataType: defaultDataType.number, tbl_width: '14%', td_class: 'al_right', display_filter: 'toCurrency', th_click_event: 'sort' },
					{ key: 'margin', groupKey: 'period', name: 'Gross Profit(%)', width: 15, dataType: defaultDataType.number, tbl_width: '14%', td_class: 'al_right', display_filter: 'toCurrency', th_click_event: 'sort' },
				];
			}
			return [
				{ key: 'partner_code', groupKey: 'period', name: 'Code', width: 20, dataType: defaultDataType.string, tbl_width: '25%', td_class: 'al_left', th_click_event: 'sort' },
				{ key: 'name', groupKey: 'period', name: 'Name', width: 20, dataType: defaultDataType.string, tbl_width: '25%', td_class: 'al_left', th_click_event: 'sort' },
				{ key: 'net_sales_amount', groupKey: 'period', name: 'Net Sales Amt($)', width: 20, dataType: defaultDataType.number, tbl_width: '25%', td_class: 'al_right', display_filter: 'toCurrency', th_click_event: 'sort' },
				{ key: 'margin', groupKey: 'period', name: 'Margin(%)', width: 20, dataType: defaultDataType.number, tbl_width: '25%', td_class: 'al_right', display_filter: 'toCurrency', th_click_event: 'sort' },
			];
		},
		allHeader() {
			return [
				{ key: 'sales_group_code', name: 'Sales Group', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'partner_code', name: 'Customer #', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'name', name: 'Customer Name', width: 30, dataType: defaultDataType.number, td_class: 'al_left' },
				{ key: 'address_state', name: 'State', width: 10, dataType: defaultDataType.number, tbl_width: '5%', td_class: 'al_left' },
				{ key: 'payment_term_code', name: 'terms', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'ship_charge_code', name: 'Ship Charge', width: 20, dataType: defaultDataType.string, tbl_width: '10%', td_class: 'al_left' },
				{ key: 'all_shipped_amount', name: 'Amount', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'all_shipping_charge', name: 'Freight', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'all_discount_amount', name: 'Discount', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'all_amount', name: 'Total', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'all_balance', name: 'balance', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'sales_number', name: '# of Trans', width: 20, dataType: defaultDataType.currency, tbl_width: '7%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'avg_sales_amount', name: 'Avg Sales', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
			];
		},
		salesHeader() {
			return [
				{ key: 'sales_group_code', name: 'Sales Group', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'partner_code', name: 'Customer #', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'name', name: 'Customer Name', width: 30, dataType: defaultDataType.number, td_class: 'al_left' },
				{ key: 'address_state', name: 'State', width: 10, dataType: defaultDataType.number, tbl_width: '5%', td_class: 'al_left' },
				{ key: 'payment_term_code', name: 'terms', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'ship_charge_code', name: 'Ship Charge', width: 20, dataType: defaultDataType.string, tbl_width: '10%', td_class: 'al_left' },
				{ key: 'sales_shipped_amount', name: 'Amount', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'sales_shipping_charge', name: 'Freight', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'sales_discount_amount', name: 'Discount', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'sales_amount', name: 'Total', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'sales_balance', name: 'balance', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'sales_number', name: '# of Trans', width: 20, dataType: defaultDataType.currency, tbl_width: '7%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'avg_sales_amount', name: 'Avg Sales', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
			];
		},
		returnHeader() {
			return [
				{ key: 'sales_group_code', name: 'Sales Group', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'partner_code', name: 'Customer #', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'name', name: 'Customer Name', width: 30, dataType: defaultDataType.number, td_class: 'al_left' },
				{ key: 'address_state', name: 'State', width: 10, dataType: defaultDataType.number, tbl_width: '5%', td_class: 'al_left' },
				{ key: 'payment_term_code', name: 'terms', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'ship_charge_code', name: 'Ship Charge', width: 20, dataType: defaultDataType.string, tbl_width: '10%', td_class: 'al_left' },
				{ key: 'return_shipped_amount', name: 'Amount', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'return_shipping_charge', name: 'Freight', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'return_discount_amount', name: 'Discount', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'return_amount', name: 'Total', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'return_balance', name: 'balance', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'return_number', name: '# of Trans', width: 20, dataType: defaultDataType.currency, tbl_width: '7%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'avg_return_amount', name: 'Avg Sales', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
			];
		},
		creditHeader() {
			return [
				{ key: 'sales_group_code', name: 'Sales Group', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'partner_code', name: 'Customer #', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'name', name: 'Customer Name', width: 30, dataType: defaultDataType.number, td_class: 'al_left' },
				{ key: 'address_state', name: 'State', width: 10, dataType: defaultDataType.number, tbl_width: '5%', td_class: 'al_left' },
				{ key: 'payment_term_code', name: 'terms', width: 15, dataType: defaultDataType.string, tbl_width: '7%', td_class: 'al_left' },
				{ key: 'ship_charge_code', name: 'Ship Charge', width: 20, dataType: defaultDataType.string, tbl_width: '10%', td_class: 'al_left' },
				{ key: 'credit_amount', name: 'Amount', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'nothing', name: 'Freight', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'nothing', name: 'Discount', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'credit_amount', name: 'Total', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'credit_balance', name: 'balance', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'credit_number', name: '# of Trans', width: 20, dataType: defaultDataType.currency, tbl_width: '7%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'avg_credit_amount', name: 'Avg Sales', width: 20, dataType: defaultDataType.number, tbl_width: '7%', td_class: 'al_right', display_filter: 'toCurrency' },
			];
		},
		async search() {
			this.search_from_date = this.from_date;
			this.search_to_date = this.to_date;

			let { data } = await apiSelectSalesByCustomer.call(this, this.search_from_date || '', this.search_to_date || '', this.customer_code_arr, this.sales_group_arr);
			this.sales_list_by_customer = data.sales_list_by_customer;
			this.total_list = data.total_list;

			this.changeMode();
		},
		async getSalesGroups() {
			const { data } = await apiSelectSalesGroupList({ active_yn: 'Y' });
			this.salesGroups = data.salesGroupList;
		},
	},
	created() {
		this.is_detail = this.init_detail_mode;

		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_salesByCustomer');
		this.$store.commit('setSubTitle', 'Report -> Sales by Customer');

		this.getSalesGroups();

		this.$nextTick(() => inputSelectOnClick());
	},
};
</script>

<style></style>
